import { render } from "./UpdateCampaignCardModal.vue?vue&type=template&id=20a6884e"
import script from "./UpdateCampaignCardModal.vue?vue&type=script&lang=js"
export * from "./UpdateCampaignCardModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__